var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { useTranslation } from "react-i18next";
import { H1, H4 } from "syf-component-library/ui/typography";
import { Inset, Stack } from "syf-component-library/ui/spacing";
import { ModalHeader } from "syf-component-library/ui/patterns/SlideInModalPortal";
import { addStyleToComponents } from "../../helpers/styleUtils";
var _a = addStyleToComponents([H1, H4], "text-align: center"), Title = _a[0], Subtitle = _a[1];
/**
 * This container is used because within Peaks the font-size was getting overridden
 * by font-size: inherit within BigIcon. So this will atleast make it inherit from the container
 */
var BigIconContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 15rem;\n"], ["\n  font-size: 15rem;\n"])));
var BigIcon = styled(FontAwesomeIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return props.theme.warning; });
/**
 * Stetches to fit full height of container, put padded elements inside to prevent
 * a single element with height: 100% + padding from overflowing.
 */
var FullHeightContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: grid;\n  height: 100%;\n"], ["\n  display: grid;\n  height: 100%;\n"])));
/**
 * Padded, horizontally and vertically centered items container with contents packed together
 */
var CenterStackedInset = styled(Inset)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: grid;\n  grid-auto-flow: row;\n  justify-items: center;\n  align-content: center;\n"], ["\n  display: grid;\n  grid-auto-flow: row;\n  justify-items: center;\n  align-content: center;\n"])));
var ErrorComponent = function (_a) {
    var error = _a.error;
    var t = useTranslation().t;
    var isAPIError = error.name.includes("HTTPError");
    var mainErrorMessage = isAPIError
        ? t("error.api.title")
        : t("error.default.title");
    return (_jsxs(FullHeightContainer, { children: [_jsx(ModalHeader, { hideClose: true, content: t("modal.header.text"), "data-cy": "account-details-header-title" }), _jsxs(CenterStackedInset, __assign({ all: "xlarge" }, { children: [_jsx(BigIconContainer, { children: _jsx(BigIcon, { icon: faExclamationTriangle }) }), _jsx(Stack, { size: "xxlarge" }), _jsx(Title, { children: mainErrorMessage }), _jsx(Stack, { size: "xxlarge" }), _jsx(Subtitle, { children: t("error.default.subtitle") })] }))] }));
};
export default ErrorComponent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ErrorFallback.js.map